import React from 'react';
import { Link,Typography } from '@mui/material';


function EOP2 (){


let url="http://localhost:3000/Login/";
let char = String.fromCharCode(13);
return(
  <div style={{'width':'100%', 'height':'100vh', 'background-color' : 'BackgroundColor' }}>
      <div  className="row">
        <div className=" c12-l-12 close__content">
          <div className="row p32">
            <div className="c12-l-3"></div>
            <div className="c12-l-6">
              <h2 className="center">Thanks & Goodbye</h2>
              <h4 className="center">You have logged out from the</h4>
              <h4 className="center">Toolease System</h4><br/>
              <p className="center" style={{'font-size': '1.75rem'}}>for Further login,</p>
              <Typography variant="h6"
                            sx={{
                              fontWeight: "400",
                              color: "white",
                              textAlign: "center",
                              fontSize: 12,
                              paddingY: 1}} >
              <Link href="url">Click here</Link>
              </Typography>
              <br /><br /><br />
              <h5 className="center">Developed by ebissoft.com</h5>

            </div>
          </div>
        </div>
      </div>
</div>
  )
}

export default EOP2;
